import * as types from './types';
export default {
   [types.SET_USERINFO](state,data){
		state.userInfo = data;
	},
    [types.SET_TOKEN](state,data){
        state.token = data;
    },
    [types.SET_REGPARAMS](state,data){
        state.regParams = data;
    },
}
